import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The `}<inlineCode parentName="p">{`Flex`}</inlineCode>{` component behaves the same as the `}<inlineCode parentName="p">{`Box`}</inlineCode>{` component except that it has `}<inlineCode parentName="p">{`display: flex`}</inlineCode>{` set by default.`}</p>
    <h2>{`Deprecation`}</h2>
    <p>{`Use `}<a parentName="p" {...{
        "href": "/Box"
      }}>{`Box`}</a>{` instead.`}</p>
    <p><strong parentName="p">{`Before`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated",
        "deprecated": true
      }}>{`<Flex flexWrap="nowrap">
  <Box p={3} color="fg.onEmphasis" bg="accent.emphasis">
    Item 1
  </Box>
</Flex>
`}</code></pre>
    <p><strong parentName="p">{`After`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated",
        "deprecated": true
      }}>{`<Box display="flex" flexWrap="nowrap">
  <Box p={3} color="fg.onEmphasis" bg="accent.emphasis">
    Item 1
  </Box>
</Box>
`}</code></pre>
    <h2>{`Default example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated live",
        "deprecated": true,
        "live": true
      }}>{`<Box borderWidth="1px" borderStyle="solid" borderColor="border.default" width={300} height={300} borderRadius={0}>
  <Flex flexWrap="nowrap">
    <Box p={3} color="fg.onEmphasis" bg="accent.emphasis">
      Item 1
    </Box>
    <Box p={3} color="fg.onEmphasis" bg="attention.emphasis">
      Item 2
    </Box>
    <Box p={3} color="fg.onEmphasis" bg="danger.emphasis">
      Item 3
    </Box>
  </Flex>
</Box>
`}</code></pre>
    <h2>{`System props`}</h2>
    <p>{`Flex components get `}<inlineCode parentName="p">{`FLEX`}</inlineCode>{`, `}<inlineCode parentName="p">{`COMMON`}</inlineCode>{`, and `}<inlineCode parentName="p">{`LAYOUT`}</inlineCode>{` system props.`}</p>
    <p>{`Read our `}<a parentName="p" {...{
        "href": "/system-props"
      }}>{`System Props`}</a>{` doc page for a full list of available props.`}</p>
    <h2>{`Component props`}</h2>
    <p><inlineCode parentName="p">{`Flex`}</inlineCode>{` does not get any additional props other than the system props mentioned above.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      